import serverApi from "../utils/serverApi"

const userService = {
    getVirtualBalance: () => serverApi({ uri: 'get-virtual-balance', method: 'GET' }),

    uploadAvatar: (data) => serverApi({ uri: 'account/upload-avatar', method: 'PUT', data }),
};

export default userService;
